import React from 'react';
import { navigateToAngular } from '../../services/navigate';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  testId?: string;
}

export function Breadcrumb({ items, testId }: BreadcrumbProps) {
  return (
    <nav aria-label="breadcrumb" data-testid={testId}>
      <ol className="breadcrumb">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className={isLast ? 'active' : undefined} data-testid="breadcrumb-item">
              {!isLast && item.href ? (
                <a href="#" onClick={e => { e.preventDefault(); navigateToAngular(item.href!); }} data-testid="breadcrumb-link">
                  {item.label}
                </a>
              ) : (
                item.label
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
